import { AppVersion } from 'app/version';
import { AppEnvironment } from './environment';


export function getReadableAppVersion() {
  return (AppEnvironment.name == 'prod' ? '' : AppEnvironment.name + ': ') + AppVersion;
}
export function getSentryReleaseVersion() {
  return AppVersion + '-' + AppEnvironment.name;
}
